// extracted by mini-css-extract-plugin
module.exports = {"CookiePage__Container":"CookiePage_CookiePage__Container__I0rUW","CookiePage__Title":"CookiePage_CookiePage__Title__HoMee","Button":"CookiePage_Button__dQUQ1"};